/**
 * Converts pixels to rem units based on the provided root font size.
 *
 * @param pixels - The pixel value to be converted to rem.
 * @param rootFontSize - The root font size in pixels (default is 16px).
 * @returns A string representing the rem value.
 */
export function pxToRem(pixels: number, rootFontSize = 16): string {
    return `${pixels / rootFontSize}rem`;
}
